import React, { useEffect, useRef, useState } from "react";

import { useQuery } from "@tanstack/react-query";
import { useHttp } from "../../../hooks/useHttp";

import { ChevronLeft, ChevronRight } from "react-feather";
import { CPagination, CPaginationItem, CTable, CTableBody, CTableDataCell, CTableHead, CTableHeaderCell, CTableRow } from "@coreui/react";

import LoadingCenter from "../../LoadingCenter";

const OutdatedTable = props => {
  const [currentPage, setCurrentPage] = useState(0);

  const request = useHttp();

  const { data: graph, isLoading } = useQuery(
    ["graph-5"],
    () => request({ url: "/dash/graph/5", method: "GET" })
  );

  async function next() {
    if (currentPage + 1 < graph.data?.length) {
      setCurrentPage(prev => prev + 1);
    }
  }

  async function previous() {
    if (currentPage > 0) {
      setCurrentPage(prev => prev - 1);
    }
  }

  return (
    <div className="card__component mb-20">
      <CPagination align="center" aria-label="Navegação da tabela de clientes" className="m-t-20">
        <span style={{ textAlign: "center" }} className="text-color">Carteira diária de clientes</span>
      </CPagination>

      {isLoading && <LoadingCenter />}

      {!isLoading && (
        <div>
          <CTable hover>
            <CTableHead>
              <CTableRow>
                <CTableHeaderCell scope="col">
                  <span className="text-color">Vendedor</span>
                </CTableHeaderCell>
                <CTableHeaderCell scope="col">
                  <span className="text-color">Qtd. de Ligações</span>
                </CTableHeaderCell>
                <CTableHeaderCell scope="col">
                  <span className="text-color">Qtd. de Chats</span>
                </CTableHeaderCell>
                <CTableHeaderCell scope="col">
                  <span className="text-color">Desperdiçado</span>
                </CTableHeaderCell>
                <CTableHeaderCell scope="col">
                  <span className="text-color">Data</span>
                </CTableHeaderCell>
              </CTableRow>
            </CTableHead>
            <CTableBody>
              {graph?.data[currentPage].map((customer, index) => {
                return (
                  <CTableRow>
                    <CTableDataCell>
                      <span className="text-color">{customer.name}</span>
                    </CTableDataCell>
                    <CTableDataCell>
                      <span className="text-color">{customer.calls}</span>
                    </CTableDataCell>
                    <CTableDataCell>
                      <span className="text-color">{customer.chats}</span>
                    </CTableDataCell>
                    <CTableDataCell>
                      <span className="text-color">{customer.nada}</span>
                    </CTableDataCell>
                    <CTableDataCell>
                      <span className="text-color">{customer.date}</span>
                    </CTableDataCell>
                  </CTableRow>
                )
              })}
            </CTableBody>
          </CTable>
        </div>
      )}

      {!isLoading && (
        <CPagination align="center" aria-label="Navegação da tabela de clientes" className="m-t-20">
          <CPaginationItem onClick={previous}><ChevronLeft /></CPaginationItem>

          <div className="d-flex flex-row align-center justify-content-center x-p-20">
            {currentPage + 1}
          </div>

          <CPaginationItem onClick={next} ><ChevronRight /></CPaginationItem>
        </CPagination>
      )}

    </div>
  );
}

export default OutdatedTable;